<template>
    <div
        v-if="dataOrder"
        class="my-5">
        <!-- Thêm ghi chú thông tin vận chuyển -->
        <div class="flex justify-center">
            <div class="flex flex-col border-2 border-dotted pl-2 pb-2 pr-2 w-fit">
                <span class="font-normal text-lg text-warning-600">
                    Ghi chú
                </span>
                <div class="flex justify-start gap-4 my-2">
                    <div class="flex justify-start gap-4 my-2 items-center">
                        <date-time
                            class="w-[90px] min-w-[90px]"
                            readonly
                            color="success" />
                        <span class="font-normal text-lg">
                            {{ $t('labels.earliestDeadline') }}
                        </span>
                    </div>
                    <div class="flex justify-start gap-4 my-2 items-center">
                        <date-time
                            class="w-[90px] min-w-[90px]"
                            readonly
                            color="warning" />
                        <span class="font-normal text-lg">
                            {{ $t('labels.latestDeadline') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <shipping-information
            :positions="dataOrder.positions"
            :condition="dataOrder.condition"
            :waiting-tasks="dataOrder.waitingTasks"
            disabled />

        <div
            v-if="dataOrder.solution === 'manualPlanning'"
            class="grid grid-cols-3 gap-3">
            <hts-form-date
                v-model="dataOrder.manualPlanning.IN"
                :label="`Thời gian in điểm ${dataOrder.positions[0]?.nodeLocationName} (vị trí 1)`"
                class="w-full"
                type="datetime"
                time-format="HH:mm"
                disabled
                :unix-time="true" />
        </div>

        <travel-detail ref="travelDetail" />
    </div>
</template>
<script setup>
import ShippingInformation from '../shipping-information.vue'
import TravelDetail from '../travel-detail.vue'
import DateTime from '../component/date-time.vue'

const props = defineProps({
  dataOrder: Object
})

const optimizeWaitingTimeRef = ref()
const shippingPlan = ref()
const travelDetail = ref()

const { dataOrder } = toRefs(props)

onMounted(() => {
  if (dataOrder?.value) {
    travelDetail.value?.show(dataOrder.value)
  }
})

onBeforeUnmount(() => {
  optimizeWaitingTimeRef.value?.close()
})
</script>
